"use client";

import { useEffect } from "react";

// Declare the custom element type for TypeScript
declare global {
  namespace JSX {
    interface IntrinsicElements {
      "gecko-coin-price-marquee-widget": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        locale?: string;
        "dark-mode"?: string;
        outlined?: string;
        "coin-ids"?: string;
        "initial-currency"?: string;
      };
    }
  }
}

const CoinGeckoPriceBanner = () => {
  useEffect(() => {
    // Load the CoinGecko widget script
    const script = document.createElement("script");
    script.src =
      "https://widgets.coingecko.com/gecko-coin-price-marquee-widget.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      const existingScript = document.querySelector(
        'script[src="https://widgets.coingecko.com/gecko-coin-price-marquee-widget.js"]'
      );
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="w-full border-b border-[rgba(255,255,255,0.04)] bg-[rgba(255,255,255,0.02)] text-[12px] opacity-80">
      <gecko-coin-price-marquee-widget
        locale="en"
        dark-mode="true"
        outlined="true"
        coin-ids=""
        initial-currency="usd"
      />
    </div>
  );
};

export default CoinGeckoPriceBanner;
